function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite/no-important';
import { childrenPropType, stylePropType, TSS_DARK_BLUE, TSS_BLUE_1, TSS_RED, TSS_GRAY, STANDARD_TEXT } from 'tss-core-lib-common';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import withProps from 'recompose/withProps';

var styles = void 0;

var enhance = compose(withState('stateValue', 'setStateValue', function (props) {
  return props.value || '';
}), withProps(function (props) {
  return { useLocalStateValue: props.value === null || !props.onChange };
}), withHandlers({
  onChange: function onChange(props) {
    return function (event) {
      if (props.onChange) {
        props.onChange(event.target.value, event);
      } else {
        props.setStateValue(event.target.value);
      }
    };
  },
  onBlur: function onBlur(props) {
    return function (event) {
      return props.onBlur && props.onBlur(event.target.value, event);
    };
  }
}));

var Input = function Input(_ref) {
  var children = _ref.children,
      type = _ref.type,
      value = _ref.value,
      stateValue = _ref.stateValue,
      style = _ref.style,
      validationError = _ref.validationError,
      useLocalStateValue = _ref.useLocalStateValue,
      containerStyle = _ref.containerStyle,
      className = _ref.className,
      maxLength = _ref.maxLength,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      setStateValue = _ref.setStateValue,
      inputRef = _ref.inputRef,
      props = _objectWithoutProperties(_ref, ['children', 'type', 'value', 'stateValue', 'style', 'validationError', 'useLocalStateValue', 'containerStyle', 'className', 'maxLength', 'onChange', 'onBlur', 'setStateValue', 'inputRef']);

  return React.createElement(
    'div',
    { className: css(styles.container, containerStyle) },
    React.createElement('input', Object.assign({}, props, {
      ref: inputRef,
      type: type,
      maxLength: maxLength,
      value: !useLocalStateValue ? value : stateValue,
      className: className + ' ' + css(STANDARD_TEXT, styles.input, style, validationError && styles.validationError),
      onChange: onChange,
      onBlur: onBlur
    })),
    children
  );
};

Input.propTypes = {
  children: childrenPropType,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  stateValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  style: stylePropType,
  className: PropTypes.string,
  containerStyle: stylePropType,
  validationError: PropTypes.bool,
  useLocalStateValue: PropTypes.bool.isRequired,
  inputRef: PropTypes.func,
  setStateValue: PropTypes.func.isRequired,
  maxLength: PropTypes.number,

  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired
};

Input.defaultProps = {
  children: null,
  type: 'text',
  value: null,
  style: null,
  maxLength: 64,
  className: '',
  containerStyle: null,
  validationError: false,
  inputRef: null
};

styles = StyleSheet.create({
  container: {
    height: '4.6rem',
    minWidth: '23rem',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    backgroundColor: 'white',
    cursor: 'text'
  },

  input: {
    alignSelf: 'stretch',
    color: TSS_DARK_BLUE(),
    border: '2px solid ' + TSS_BLUE_1(),
    width: '100%',
    outline: 0,
    margin: 0,
    padding: '0 0 0 1.2rem',
    ':focus': {
      borderColor: TSS_GRAY()
    }
  },

  validationError: {
    borderColor: TSS_RED()
  }
});

export default enhance(Input);